/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_ManageInputs */

const en_action_manage = /** @type {(inputs: Action_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage`)
};

const es_action_manage = /** @type {(inputs: Action_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar`)
};

const fr_action_manage = /** @type {(inputs: Action_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer`)
};

const de_action_manage = /** @type {(inputs: Action_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalten`)
};

const id_action_manage = /** @type {(inputs: Action_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelola`)
};

/** @type {(inputs: Action_ManageInputs) => LocalizedString} */
const ja_action_manage = en_action_manage;

/** @type {(inputs: Action_ManageInputs) => LocalizedString} */
const zh_action_manage = en_action_manage;

/** @type {(inputs: Action_ManageInputs) => LocalizedString} */
const ar_action_manage = en_action_manage;

/** @type {(inputs: Action_ManageInputs) => LocalizedString} */
const it_action_manage = en_action_manage;

/** @type {(inputs: Action_ManageInputs) => LocalizedString} */
const ru_action_manage = en_action_manage;

/** @type {(inputs: Action_ManageInputs) => LocalizedString} */
const pt_action_manage = en_action_manage;

/** @type {(inputs: Action_ManageInputs) => LocalizedString} */
const ko_action_manage = en_action_manage;

/**
* | output |
* | --- |
* | "Manage" |
*
* @param {Action_ManageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_manage = /** @type {((inputs?: Action_ManageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_ManageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_manage(inputs)
	if (locale === "es") return es_action_manage(inputs)
	if (locale === "fr") return fr_action_manage(inputs)
	if (locale === "de") return de_action_manage(inputs)
	if (locale === "ja") return ja_action_manage(inputs)
	if (locale === "zh") return zh_action_manage(inputs)
	if (locale === "ar") return ar_action_manage(inputs)
	if (locale === "id") return id_action_manage(inputs)
	if (locale === "it") return it_action_manage(inputs)
	if (locale === "ru") return ru_action_manage(inputs)
	if (locale === "pt") return pt_action_manage(inputs)
	return ko_action_manage(inputs)
});